<template>
    <div class="Deduction">
        <div class="Deduction-content">
            <!-- 财务审批 -->
            <div class="margin-top1" style="overflow: hidden;">
                <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="100px">
                    <el-form-item label="选择子公司" prop="staffvalue">
                        <el-select
                            @change="handleSelect"
                            v-model="ruleForm.son"
                            placeholder="选择子公司"
                        >
                            <el-option
                                v-for="item in DataList"
                                :key="item.value"
                                :label="item.companyFullName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态" prop="staffvalue">
                        <el-select
                            @change="chanPayment"
                            v-model="ruleForm.staffvalue"
                            placeholder="选择状态"
                        >
                            <el-option
                                v-for="(item,index) in staff"
                                :key="index"
                                :label="item.name"
                                :value="item.state"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开始日期" prop="starttime">
                        <el-date-picker
                            class="width1"
                            v-model="ruleForm.starttime"
                            type="date"
                            placeholder="选择开始日期"
                            @change="startDate"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" prop="endtime">
                        <el-date-picker
                            class="width1"
                            v-model="ruleForm.endtime"
                            type="date"
                            placeholder="选择结束日期"
                            @change="endDate"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="汇款账户" prop="endtime">
                        <el-select
                            @change="chanPayment1"
                            v-model="ruleForm.Remittance1"
                            placeholder="选择汇款账户"
                        >
                            <el-option
                                v-for="item in remittanceList"
                                :key="item.value"
                                :label="item.bank"
                                :value="item.bank"
                            ></el-option>
                            </el-select>
                    </el-form-item>
                    <el-form-item label="手机或单据" prop="staffvalue" style="width: 28%;">
                        <el-input v-model="ruleForm.input" placeholder style="width: 60%;"></el-input>
                        <el-button
                            type="primary"
                            style="margin-left: 5px;"
                            class="search"
                            @click="search2"
                        >搜索</el-button>
                        <el-button type="primary" class="search" @click="searchReset">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column width="170" prop="documentNumber" label="单据编号" align="center"></el-table-column>
                <el-table-column width="170" prop="companyCode" label="公司编码" align="center"></el-table-column>
                <el-table-column width="120" prop="telephone" label="电话" align="center"></el-table-column>
                <el-table-column width="120" prop="accountsReceivable" label="汇款账户" align="center"></el-table-column>
                <el-table-column width="80" prop="reportedAmount" label="充值金额" align="center"></el-table-column>
                <el-table-column prop="uploadCertificate" label="凭证图片" align="center">
                    <template slot-scope="scope">
                        <el-image
                            class="voucher"
                            style="width: 70px; height: 70px"
                            :src="scope.row.repayImage.url"
                            :preview-src-list="scope.row.repayImage.repayCredentialsList"
                        >
                        <div slot="error" class="image-slot">
                            <img src="../../../assets/imags/暂无图片.png" alt="" style="width:70px;height:60px;">
                        </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="remarks" label="备注" align="center"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isAudit === 1">审核通过</span>
                        <span v-if="scope.row.isAudit === 2">未审核</span>
                        <span v-if="scope.row.isAudit === 3">审核未通过</span>
                    </template>
                </el-table-column>
                <el-table-column width="270" prop="address" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            :loading="PassLoading"
                            type="primary"
                            @click="through(scope.row)"
                            v-if="scope.row.isAudit === 2"
                        >审核通过</el-button>
                        <el-button
                            :loading="NoPassLoading"
                            type="danger"
                            @click="nothrough(scope.row)"
                            v-if="scope.row.isAudit === 2"
                        >不予通过</el-button>
                        <span v-if="scope.row.isAudit === 1">审核通过</span>
                        <span v-if="scope.row.isAudit === 3">不予通过</span>
                    </template>
                </el-table-column>
                <el-table-column prop="reviewer" label="操作员" align="center"></el-table-column>
                <el-table-column width="100" prop="createTime" label="日期" align="center"></el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
    name: "Deduction",
    data() {
        return {
            str: "",
            DataList: [],
            remittanceList:[],
            tableData: [],
            sonId: "",
            currentPage: 1,
            pagesize: 50,
            size: 50,
            total: 0,
            PassLoading:false,
            NoPassLoading:false,

            staff: [
                { state: 1, name: "审核通过", value: 0 },
                { state: 2, name: "未审核", value: 1 },
                { state: 3, name: "审核未通过", value: 2 }
            ],
            checked: true,
            select: "",
            ruleForm: {
                son: "", //选择子公司
                staffvalue: "", //选择状态
                starttime: "", //开始时间
                endtime: "", //结束时间
                input: "",
                Remittance1:""
            }
        };
    },
    mounted() {},
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.SonCompany();
        this.search();
        this.remittance();
    },
    methods: {
        remittance(){
            var obj = {
                companyId: this.str.company_id
            };
            ajaxPost(Baseurl + "remittanceAccountController/selectRemittanceAccountByCompanyId",obj).then(res => {
                this.remittanceList = res.data.data;
                console.log(res.data)
            });
        },
        SonCompany() {
            var obj = {
                id: this.str.company_id
            };
            ajaxPost(Baseurl + "companyController/selectChildCompanyByCompanyId",obj).then(res => {
                this.DataList = res.data.data;
            });
        },
        chanPayment1(val){
            console.log(val)
            this.ruleForm.Remittance1 = val
        },
        // 选择子公司
        handleSelect(val) {
            this.ruleForm.son = val;
        },
        //选择状态
        chanPayment(val) {
            this.ruleForm.staffvalue = val;
        },
        //选择开始日期
        startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
            console.log(this.ruleForm.starttime);
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
            console.log(this.ruleForm.endtime);
        },
        search2(){
            this.currentPage = 1
            this.search()
        },
        search() {
            var obj = {
                pid: this.str.company_id,
                companyId: this.ruleForm.son,
                isAudit: this.ruleForm.staffvalue,
                beginDate: this.ruleForm.starttime,
                endDate: this.ruleForm.endtime,
                accountsReceivable:this.ruleForm.Remittance1,
                searchStr: this.ruleForm.input,
                page: this.currentPage,
                size: this.size
            };
            ajaxPost(Baseurl + "selfReportController/selectFinancialApprovalInfo",obj).then(res => {
                this.tableData = res.data.data.list;
                this.total = res.data.data.total;
            });
        },
        searchReset() {
            this.ruleForm.son = "";
            this.ruleForm.staffvalue = "";
            this.ruleForm.starttime = "";
            this.ruleForm.endtime = "";
            this.ruleForm.input = "";
            this.ruleForm.Remittance1 = "";
            this.currentPage = 1
            this.search();
        },
        through(val) {
            this.PassLoading = true
            var obj = {
                id: val.id,
                isAudit: 1,
                rid: this.str.rid
            };
            ajaxPost(Baseurl + "selfReportController/updateSelfReportIsAudit",obj).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        message: "审核通过",
                        type: "success"
                    });
                    this.search();
                }else{
                    this.$message.error(res.data.data)
                }
                this.PassLoading = false
            });
        },
        nothrough(val) {
            this.NoPassLoading = true
            var obj = {
                id: val.id,
                isAudit: 3,
                rid: this.str.rid
            };
            ajaxPost(Baseurl + "selfReportController/updateSelfReportIsAudit",obj).then(res => {
                if (res.data.code == 200) {
                    this.$message.error("不予通过");
                    this.search();
                }else{
                    this.$message.error(res.data.data)
                }
                this.NoPassLoading = false
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        }
    }
};
</script>

<style lang="scss">
.Deduction {
    width: 98%;
    margin-bottom: 50px;
    overflow: hidden;
    .Deduction-content {
        margin-top: 20px;
        .el-form-item {
            overflow: hidden;
            width: 18%;
            margin-bottom: 18px;
            float: left;
        }
        .Reportform_tiem {
            overflow: hidden;
            border-top: 1px solid #eee;
            padding: 15px 0;
            .search-result-text {
                font-size: 14px;
                color: #606266;
                padding: 0;
            }
            .el-radio-group {
                display: inline-block;
                line-height: 1;
                vertical-align: middle;
                font-size: 0;
                margin-left: 20px;
            }
        }
        .paging {
            width: 40%;
            margin: 20px auto;
        }
        .page {
            position: fixed;
            width: 100%;
            bottom: 0;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
        }
    }
}
</style>
